import { useManagementControlsRisk } from 'api/saq/hooks/useManagementControlsRisk/useManagementControlsRisk';
import { ColumnInfo, ManagementControlsType, RiskInfo, Section } from 'api/saq/types';
import { MCSectionContainer } from 'screens/saq/SaqRisksTable.styles';
import { useQuestionnaire } from 'api/saq/hooks/queries';
import { Typography } from '@material-ui/core';
import { EditableScoresTable } from 'components/EditableScoresTable/EditableScoresTable';
import { Spinner } from 'atoms/spinner/Spinner';

const managementControlsColumns = [
  { name: 'Sub-section', property: 'subsectionName' },
  { name: 'Question', property: 'question' }
] as ColumnInfo<ManagementControlsType>[];

export const ManagementControls = () => {
  const { data: questionnaire, isLoading: isLoadingQuestionnaire } = useQuestionnaire();
  const { data, allScores, isLoading } = useManagementControlsRisk();

  const getSectionInfo = (section: Section) =>
    data.filter((row: ManagementControlsType) =>
      section.children.map((subsection: Section) => subsection.id)
        .includes(row.subsectionId)
    );

  if (isLoadingQuestionnaire || isLoading) {
    return <Spinner/>;
  }

  return (
    <>
      <Typography variant="h6">Risk: Management Controls - question scores</Typography>
      {questionnaire && questionnaire.sections.map((section: Section) => (
        <MCSectionContainer key={`${section.name} section MC Scores`}>
          <EditableScoresTable
            title={section.name}
            riskInfo={{ data: getSectionInfo(section), allScores, isLoading } as RiskInfo<ManagementControlsType>}
            columns={managementControlsColumns}
          />
        </MCSectionContainer>
      ))}
    </>
  );
};
